module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("Cast of Characters")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Patrick Abbott.")]), _vm._v(" A tall, lanky private detective from San Francisco, about to become a U.S. Marine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Jean Abbott.")]), _vm._v(" His brand-new wife, who wants to make the most of what time they have together before Pat reports for duty.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ellen Bland.")]), _vm._v(" A calm, collected woman whom Pat knew in Paris and who brings out the protective instinct in most men. Jean distrusts her.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Louis Bland.")]), _vm._v(" Her nasty, controlling ex-husband who still exerts a powerful hold over Ellen and their children.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dick Bland.")]), _vm._v(" Their 16-year-old son, already on the road to being an alcoholic.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Susan Bland.")]), _vm._v(" Their 18-year-old daughter, outspoken and youthfully self-absorbed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Anna Forbes.")]), _vm._v(" Louis’s former nursemaid, now the family housekeeper, a rude, sour-faced woman who despises Ellen but still adores Louis.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hank Rawlings.")]), _vm._v(" A chemical engineer who’s deeply in love with Ellen.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mary Kent.")]), _vm._v(" An expatriate who fled occupied France. Ruthless and overbearing, she’s considered a good match for Louis, who is expected to marry her.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Daphne Garnett.")]), _vm._v(" Another of the Blands’ Parisian friends now living in New York. A seemingly silly woman, she’s more perceptive than people expect.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Clint Moran.")]), _vm._v(" Another refugee, indolent and enigmatic and an inventive pianist. Flat broke, he lives in a flophouse. He and Louis go back a long way.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bill Reynolds.")]), _vm._v(" Susan’s fiancé, who’s serving in the Merchant Marines.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dr. Maxton Seward.")]), _vm._v(" The family physician, fat and sleek and opportunistic.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Patrolman Isaac Goldberg.")]), _vm._v(" Conscientious to a fault, he will never believe that Pat and Jean are really married.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lieutenant Jeffry Dorn.")]), _vm._v(" A deceptively angelic-looking police detective.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Laura Gilbert.")]), _vm._v(" Hank’s beautiful, dedicated secretary, in love with her boss.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sarah Howe.")]), _vm._v(" The fussy old maid who lives across the hall from Laura.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2effc096","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Fm01.vue
// module id = 72
// module chunks = 0